import axios from 'axios';
import swal from "sweetalert";
import {
    loginConfirmedAction,
    logout,
} from '../store/actions/AuthActions';
const axiosInstance = axios.create({
    // baseURL: `http://localhost:4000/api/v1/`,
    baseURL: `https://foodhub-api2.herokuapp.com/api/v1/`,
});
export function signUp(email, password) {
    //axios call
    const postData = {
        email,
        password,
        returnSecureToken: true,
    };
    return axiosInstance.post(
        `auth/signup`,
        postData,
    );
}

export function login(email, password) {
    const postData = {
        email,
        password,
        returnSecureToken: true,
    };
    
    return axiosInstance.post(
        `auth/user/signinvendor`,
        postData,
    );
}

export function phoneUser(phone) {
    const postData = {
        phone,
        returnSecureToken: true,
    };

    return axiosInstance.post(
        `user/check-phone-user`,
        postData,
    );
}


export function phoneLogin(phone, password) {
    const postData = {
        phone,
        password,
        returnSecureToken: true,
    };

    return axiosInstance.post(
        `auth/user/signinvendor`,
        postData,
    );
}


export function forgotPassword(email) {
    const postData = {
        email,
        returnSecureToken: true,
    };

    return axiosInstance.post(
        `user/check-email-user`,
        postData,
    );
}


export function updatePassword(password,email) {
    const postData = {
        password,
        returnSecureToken: true,
    };

    return axiosInstance.put(
        `user/set-user-password?email=` + email,
        postData,
    );
}

export function formatError(errorResponse) {
    console.log(errorResponse);
    switch (errorResponse.message) {
        case 'EMAIL_EXISTS':
            //return 'Email already exists';
            swal("Oops", "Email already exists", "error");
            break;
        case 'EMAIL_NOT_FOUND':
            //return 'Email not found';
           swal("Oops", "Email not found", "error",{ button: "Try Again!",});
           break;
        case 'INVALID_PASSWORD':
            //return 'Invalid Password';
            swal("Oops", "Invalid Password", "error",{ button: "Try Again!",});
            break;
        case 'USER_DISABLED':
            return 'User Disabled';
        case 'NETWORK_ERROR':
            swal("Oops", "Something went wrong", "error",{ button: "Try Again!",});
            break;
        default:
            return '';
    }
}

export function saveTokenInLocalStorage(tokenDetails) {
    // tokenDetails.expireDate = new Date(
    //     new Date().getTime() + tokenDetails.expiresIn * 1000,
    // );
    localStorage.setItem('userDetails', JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, timer, history) {
    setTimeout(() => {
        dispatch(logout(history));
    }, timer);
}

export function checkAutoLogin(dispatch, history) {
    const tokenDetailsString = JSON.parse(localStorage.getItem('userDetails'));

    // if (history.location.pathname != '/register' || history.location.pathname != '/forgot-password') {
    //     return;
    // }

    // if (tokenDetailsString === null) {
    //     dispatch(logout(history));
    //     return;
    // }

    if (!tokenDetailsString) {
        console.log('ok');
        dispatch(logout(history));
        return;
    }
    
    // tokenDetails = JSON.parse(tokenDetailsString);
    // let expireDate = new Date(tokenDetails.expireDate);
    // let todaysDate = new Date();
    
    // if (todaysDate > expireDate) {
    //     dispatch(logout(history));
    //     return;
    // }
    dispatch(loginConfirmedAction(tokenDetailsString));

    // const timer = expireDate.getTime() - todaysDate.getTime();
    // runLogoutTimer(dispatch, timer, history);
}
